import { Injectable } from '@angular/core';

import { AuthService } from "../../shared/services/auth.service";
import { manutencoesRoute } from "./data.service";

@Injectable()
export class ManutencaoService {

    constructor(
        private _authService: AuthService
    ) { }

    goToSetting() {
        let router: string = manutencoesRoute + '/configuracoes';
        this._authService.navigateTo(router);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/shared/manutencao.service.ts
 **/